var path = 'areas/projects/triggers/trigger_edit.html';
var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href='#/projects/{{ project.Slug }}/triggers/edit/{{projectTrigger.Id}}'>{{projectTrigger.Name}}</a></li> </script> <div class=row> <div class=\"col-sm-9 col-md-9 col-lg-9\"> <project-trigger-editor></project-trigger-editor> </div> <div class=\"other-actions col-sm-3 col-md-3 col-lg-3\"> <h3>Delete</h3> <div> <p>Deleting project triggers will stop any auto-deployments related to this trigger.</p> <delete-button model=projectTrigger what=\"Project Trigger\" redirect=/projects/{{project.Slug}}/triggers></delete-button> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/triggers/trigger_edit.html
// module id = 1245154593998515
// module chunks = 1